
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/amazon-ads",
      function () {
        return require("private-next-pages/destinations/amazon-ads.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/amazon-ads"])
      });
    }
  